import type { WidgetDefinition } from "@nexus/widget-sdk";
import { manifest, Component, defaultConfig } from ".";
import { settings } from "./settings";

export const definition: WidgetDefinition = {
  id: manifest.id,
  module: { manifest, Component, defaultConfig },
  catalog: {
    description: manifest.description,
    domain: "ip-blocking",
    visual: "Summary",
    purposes: ["reporting"],
    audiences: ["analyst", "client"],
  },
  layout: { kind: "content" },
  settings,
  defaultLayoutClassName: "col-span-12 xl:col-span-4",
};
